import React from 'react';

import download from '../assets/download.svg';
import caution from '../assets/caution.svg';
import './ResultHeader.css';

const ResultHeader = (props) => {

  return (
    <div className="result-header">
      <div className="caution-note">
        <img src={caution} alt="caution" className="caution" />
        <h1>
          This is <span className="bold">not</span> a medical advice. Your prescription has been sent to a <span className="bold">doctor</span> on <span className="bold">e-sanjeevani</span> app. Please wait for a response!
        </h1>
        <h2 className="close-button">x</h2>
      </div>
      <div className="end-results">
        <h1>Your Results</h1>
        <div className="download-button" onClick>
          <img src={download} alt="download" className="download" />
          <h2>Download Report</h2>
        </div>
      </div>
    </div>
  )
}

export default ResultHeader;